module.exports = __webpack_public_path__ + "img/strip-3.5557e851.svg";